"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProductionApi = void 0;
var tslib_1 = require("tslib");
/* eslint-disable */
/* 此代码由工具自动生成,不要直接修改,以免下次生成会丢失 */
var di_1 = tslib_1.__importDefault(require("@jsmodules/di"));
var getApi_1 = tslib_1.__importDefault(require("../../getApi"));
var ProductionApi = /** @class */ (function () {
    function ProductionApi() {
        this.http = getApi_1.default('api_v1');
    }
    /**
     * 查询橱窗商品
     * @method GET 查询橱窗商品
     *
     */
    ProductionApi.prototype.showcase = function () {
        return this.http
            .url("/api/Production/showcase")
            .support('GET');
    };
    /**
     * 根据Id获取商品,修改商品
     * @method GET 根据Id获取商品
     * @method PUT 修改商品
     *
     * @params id 无说明
     */
    ProductionApi.prototype.ProductionById = function (id) {
        return this.http
            .url("/api/Production/" + id)
            .addSecurityHeaders()
            .support('GET', 'PUT');
    };
    /**
     * 查询商品,添加商品
     * @method GET 查询商品
     * @method POST 添加商品
     *
     */
    ProductionApi.prototype.Production = function () {
        return this.http
            .url("/api/Production")
            .addSecurityHeaders()
            .support('GET', 'POST');
    };
    ProductionApi.diOptions = di_1.default.options({
        name: "ProductionApi",
        scope: "Singleton"
    });
    return ProductionApi;
}());
exports.ProductionApi = ProductionApi;
exports.default = ProductionApi;
